import { type ReactElement, type ReactNode } from 'react'
import { Divider, Grid, Stack } from '@mantine/core'
import { type PreferenceGroup } from '@front/model'
import { TButton } from '../buttons'
import { type PreferenceGroupOrAll } from './Context'

type Props = {
  categories: readonly PreferenceGroup[]
  currentGroup: PreferenceGroupOrAll
  onSelect: (category: PreferenceGroup) => void
  children: ReactNode
}

export const PreferenceCategorySidebar = ({ categories, currentGroup, onSelect, children }: Props): ReactElement => {
  return (
    <Grid>
      <Grid.Col span='content'>
        <Stack>
          {categories.map((category) => {
            const isSelected = currentGroup === category
            return (
              <TButton
                aria-current={isSelected ? 'true' : undefined}
                color={isSelected ? 'brand' : 'neutral'}
                justify='left'
                key={category}
                variant='ghost'
                onClick={() => onSelect(category)}
              >
                {category}
              </TButton>
            )
          })}
        </Stack>
      </Grid.Col>
      <Divider mx='xl' orientation='vertical' />
      <Grid.Col span='auto'>{children}</Grid.Col>
    </Grid>
  )
}
